<template>
  <div class="book-content">
    <FDBannerImg />
    <div class="container">
      <div class="navigation">
        <div class="page-cen">
          <div class="navigation-item">
            <a href="javascript:void(0)" @click="goPage('/home')">首页</a
            >&nbsp;&gt;
            <a href="javascript:void(0)" @click="goPage('/bookList')"
              >新书上架</a
            >&nbsp;&gt;
            <a class="active" href="javascript:void(0)">图书详情</a>
          </div>
        </div>
      </div>

      <div class="bookContainer">
        <div class="bookInfo">
          <div class="imgBox">
            <img :src="data.cover" />
          </div>
          <div class="infoBox">
            <div class="title">{{ data.title }}</div>
            <p v-for="item in infoOptions" :key="item.id">
              {{ item.label }}：<span>{{ data[item.value] }}</span>
            </p>
          </div>
        </div>

        <div class="bar">图书详情</div>

        <div id="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "element-ui";
import FDBannerImg from "@c//FDBannerImg";
import { post, get } from "@u/request";

export default {
  name: "",
  components: { FDBannerImg, Pagination },
  data() {
    return {
      copyright: {},
      data: {},
      infoOptions: [
        {
          value: "isbn",
          label: "ISBN",
        },
        {
          value: "author",
          label: "作者",
        },
        {
          value: "publisher",
          label: "出版社",
        },
        {
          value: "year",
          label: "出版年",
        },
        {
          value: "page",
          label: "页数",
        },
        {
          value: "callNumber",
          label: "索书号",
        },
        {
          value: "viewNum",
          label: "浏览量",
        },
        // {
        //   value: 6,
        //   label: "主题",
        // },
      ],
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    // 缓存页面name
    catche() {
      return this.$store.getters.includeArr;
    },
    key() {
      return this.$router.fullPath;
    },
  },
  methods: {
    async getDetail() {
      const { data } = await get(`lib/book/pc/detail?id=${this.id}`);
      this.data = data;
      var content = document.getElementById("content");
      content.innerHTML = data.info;
    },
    goPage(url) {
      this.$router.push(url);
    },
  },
  created() {
    this.getDetail();
  },
};
</script>

<style scoped lang="scss">
.container {
  background-color: #f7f7f7;
  padding-bottom: 50px;
  width: 100%;
  .bookContainer {
    background-color: #fff;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    .bookInfo {
      display: flex;
      .imgBox {
        overflow: hidden;
        width: 270px;
        height: 360px;
        text-align: center;
        padding-top: 10px;
        margin-right: 60px;
        img {
          width: 100%;
          height: 100%;
          border: 0;
        }
      }
      .infoBox {
        padding: 10px;
        .title {
          line-height: 32px;
          margin-bottom: 10px;
          font-weight: 700;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #094d99;
          font-size: 20px;
        }
        p {
          margin-bottom: 10px;
          font-size: 14px;
          color: #999;
          span {
            color: #515a6e;
          }
        }
      }
    }

    .bar {
      margin-top: 40px;
      width: 100%;
      color: #212121;
      font-size: 16px;
      line-height: 40px;
      font-weight: 700;
      border-bottom: 2px solid #e4e7ed;
    }

    #content {
      padding: 30px 20px 0;
    }
  }
}
</style>
